const TMDB = {
    api_key: '<REPLACE_THIS_WITH_TMDB_API_KEY>',
    films: [
      {
        "id": 346364,
          "title": "It",
          "poster_path": "/9E2y5Q7WlCVNEhP5GiVTjhEhx1o.jpg",
          "backdrop_path": "/tcheoA2nPATCm2vvXw2hVQoaEFD.jpg",
          "overview": "In a small town in Maine, seven children known as The Losers Club come face to face with life problems, bullies and a monster that takes the shape of a clown called Pennywise.",
          "release_date": "2017-09-05"
      },
      {
        "id": 343668,
          "title": "Kingsman: The Golden Circle",
          "poster_path": "/pKESfn2Pdy0b7drvZHQb7UzgqoY.jpg",
          "backdrop_path": "/uExPmkOHJySrbJyJDJylHDqaT58.jpg",
          "overview": "When an attack on the Kingsman headquarters takes place and a new villain rises, Eggsy and Merlin are forced to work together with the American agency known as the Statesman to save the world.",
          "release_date": "2017-09-20"
      },
      {
        "id": 339403,
          "title": "Baby Driver",
          "poster_path": "/dN9LbVNNZFITwfaRjl4tmwGWkRg.jpg",
          "backdrop_path": "/goCvLSUFz0p7k8R10Hv4CVh3EQv.jpg",
          "overview": "After being coerced into working for a crime boss, a young getaway driver finds himself taking part in a heist doomed to fail.",
          "release_date": "2017-06-28"
      },
      {
          "id": 335984,
          "title": "Blade Runner 2049",
          "poster_path": "/cbRQVCia0urtv5UGsVFTdqLDIRv.jpg",
          "backdrop_path": "/zfWPeRgYpRjPZLGwwkfnTfaFnNh.jpg",
          "overview": "Thirty years after the events of the first film, a new blade runner, LAPD Officer K, unearths a long-buried secret that has the potential to plunge what's left of society into chaos. K's discovery leads him on a quest to find Rick Deckard, a former LAPD blade runner who has been missing for 30 years.",
          "release_date": "2017-10-04"
      },
      {
        "id": 381283,
          "title": "mother!",
          "poster_path": "/qmi2dsuoyzZdJ0WFZYQazbX8ILj.jpg",
          "backdrop_path": "/uuQpQ8VDOtVL2IO4y2pR58odkS5.jpg",
          "overview": "A couple's relationship is tested when uninvited guests arrive at their home, disrupting their tranquil existence.",
          "release_date": "2017-09-13"
      },
      {
        "id": 374720,
          "title": "Dunkirk",
          "poster_path": "/ebSnODDg9lbsMIaWg2uAbjn7TO5.jpg",
          "backdrop_path": "/eEMsuUV1ZCiruQwzUE3BYpqZCwr.jpg",
          "overview": "The miraculous evacuation of Allied soldiers from Belgium, Britain, Canada and France, who were cut off and surrounded by the German army from the beaches and harbor of Dunkirk, France, between May 26th and June 4th 1940, during the Battle of France in World War II.",
          "release_date": "2017-07-19"
      },
      {
        "id": 415842,
          "title": "American Assassin",
          "poster_path": "/o40BAqdTQHiN3cUfpgieDUYI71z.jpg",
          "backdrop_path": "/puKZWmBIpuEMwGCn2hZkublG1rO.jpg",
          "overview": "Following the murder of his fiancée, Mitch Rapp trains under the instruction of Cold War veteran Stan Hurley. The pair then is enlisted to investigate a wave of apparently random attacks on military and civilian targets.",
          "release_date": "2017-09-14"
      },
      {
        "id": 390043,
          "title": "The Hitman's Bodyguard",
          "poster_path": "/5CGjlz2vyBhW5xHW4eNOZIdgzYq.jpg",
          "backdrop_path": "/7KsqfXDECZMryX1Rv4RKsT7SIjQ.jpg",
          "overview": "The world's top bodyguard gets a new client, a hit man who must testify at the International Court of Justice. They must put their differences aside and work together to make it to the trial on time.",
          "release_date": "2017-08-16"
      },
      {
        "id": 316154,
          "title": "The Bad Batch",
          "poster_path": "/7o14VaMphEIzPwzeW6FP3A6zb4W.jpg",
          "backdrop_path": "/aQ06MnEDLh9X3ZOtY21UD2XB197.jpg",
          "overview": "In a desert wasteland in Texas, a muscled cannibal breaks one important rule: don’t play with your food.",
          "release_date": "2017-06-23"
      }
    ]
  }
  
  export default TMDB;